const SquareIcon = ({ color }) => (
  <span
    style={{
      backgroundColor: color,
      display: 'inline-block',
      width: '10px',
      height: '10px',
      margin: '3px 7px 3px 3px',
      verticalAlign: 'middle'
    }}
  />
)

export default SquareIcon
